import * as ACTION from "./addContactOptionActionTypes";

export const getContactLimit = payload => ({
    type: ACTION.GET_CONTACT_LIMIT,
    payload: payload
});

export const getContactLimitSuccess = payload => ({
    type: ACTION.GET_CONTACT_LIMIT_SUCCESS,
    payload: payload
});

export const getContactLimitFailure = payload => ({
    type: ACTION.GET_CONTACT_LIMIT_FAILURE,
    payload: payload
});

export const getUserPolicyOptions = payload => ({
    type: ACTION.GET_POLICY_OPTION,
    payload: payload
});

export const getUserPolicyOptionsSuccess = payload => ({
    type: ACTION.GET_POLICY_OPTION_SUCCESS,
    payload: payload
});

export const getUserPolicyOptionsFailure = payload => ({
    type: ACTION.GET_POLICY_OPTION_FAILURE,
    payload: payload
});

export const getInsuranceCompanyOptions = payload => ({
    type: ACTION.GET_INSURANCE_COMPANIES_OPTION,
    payload: payload
});

export const getInsuranceCompanyOptionsSuccess = payload => ({
    type: ACTION.GET_INSURANCE_COMPANIES_OPTION_SUCCESS,
    payload: payload
});

export const getInsuranceCompanyOptionsFailure = payload => ({
    type: ACTION.GET_INSURANCE_COMPANIES_OPTION_FAILURE,
    payload: payload
});


